import { BaseUnit } from './BaseUnit';
import { Enemy } from '../Enemy';
import { Wall } from '../Wall';
import { BUILDER } from '../../config';
import { StickFigureGraphics } from '../../rendering/StickFigureGraphics';
import { achievementManager } from '../../managers/AchievementManager';

export class Builder extends BaseUnit {
  private repairTimer: number = 0;
  private hammerPhase: number = 0;
  private wall: Wall;
  elderRepairMult: number = 1;

  constructor(scene: Phaser.Scene, x: number, y: number, slotIndex: number, wall: Wall) {
    super(scene, x, y, slotIndex);
    this.wall = wall;

    // We adjust Y slightly so the 32x32 sprite stands firmly on the wall top
    this.sprite.setTexture('builder_idle_v3');
    this.sprite.setPosition(x, y - 16);
    this.sprite.setOrigin(0.5, 0.5);
    this.sprite.setDisplaySize(32, 32);

    this.draw();
  }

  getRepairRate(): number {
    const achRepairBonus = achievementManager.getBonuses().builderRepair;
    return BUILDER.baseRepairRate * this.repairRateMult * this.stackCount * (1 + achRepairBonus) * this.elderRepairMult;
  }

  update(time: number, delta: number, _enemies: Enemy[]): void {
    this.hammerPhase += delta * 0.004;

    this.repairTimer -= delta;
    if (this.repairTimer <= 0) {
      if (this.wall.currentHP < this.wall.maxHP) {
        this.repairTimer = BUILDER.repairInterval * this.repairIntervalMult;
        this.wall.repair(this.getRepairRate());
      } else {
        this.repairTimer = 0;
      }
    }

    this.draw();
  }

  draw(): void {
    this.graphics.clear();

    // Determine if we should show hammering frame
    // hammerPhase is an increasing number. Let's use sine wave to pulse the hammering.
    const isHammering = Math.sin(this.hammerPhase) > 0;

    this.sprite.setTexture(isHammering ? 'builder_hammering_v3' : 'builder_idle_v3');

    // Still draw upgrade orbs via graphics if needed, matching the old behavior
    if (this.level > 1) {
      this.graphics.fillStyle(0xffd700, 1);
      for (let i = 0; i < Math.min(this.level - 1, 5); i++) {
        this.graphics.fillCircle(this.x - 8 + i * 4, this.y + 16, 1.5);
      }
    }
  }

}
